<template>
  <div class="home-view internal">
    <section class="form">
    </section> <!-- /.slide-status -->
  </div>
</template>

<script>
export default {
  name: 'politica-privacidade',

  mounted () {
    window.location.href = 'https://www.fibraexperts.com.br/files/politica-privacidade.pdf'
  }
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  h2
    font-weight: 600
    margin-bottom: 15px
    text-align: left
    margin-top: 40px
    display: block
    font-size: 18px

  p
    font-size: 14px
    margin-bottom: 20px
    display: block
</style>
